import React from 'react';

// Components
import { Button } from '@capintel/component-lib/button';
import { SecondaryLink } from '../../../../components/buttons';

// Utils
import { formatMessage, FormattedMessage } from '../../../../../utils/i18n';

// Images
import { Input } from '../../../../components/inputs';

type Props = {
  gracePeriod?: number;
  helpUrl: string;
  loading: boolean;
  qrcode: string;
  secret: string;
  primaryAction: () => void;
  onCancel?: () => void;
};

const SetupStep = ({ gracePeriod, helpUrl, onCancel, loading, qrcode, secret, primaryAction }: Props) => (
  <div className="two-factor-step-content two-factor-setup-step">
    <h3 className="two-factor-auth-header">
      <FormattedMessage id="TwoFactorAuthentication.Headers.EnableTwoFactorAuth" />
    </h3>
    <p className="two-factor-auth-text">
      <FormattedMessage id="TwoFactorAuthentication.Texts.UseYourAuthApp" />
      &nbsp;
      <a rel="noreferrer" target="_blank" href={helpUrl}>
        <FormattedMessage id="TwoFactorAuthentication.Buttons.FindOutMore" />
      </a>
    </p>
    <div className="two-factor-auth-qr-container">{qrcode && secret && <img src={qrcode} alt={secret} />}</div>
    <h4 className="two-factor-auth-line-header">
      <span className="header-text">
        <FormattedMessage id="TwoFactorAuthentication.Headers.CantScan" />
      </span>
    </h4>
    <p className="two-factor-auth-text">
      <FormattedMessage id="TwoFactorAuthentication.Texts.EnterTheFollowing" />
    </p>
    {secret && (
      <Input
        label={formatMessage('TwoFactorAuthentication.Headers.SetupCode')}
        hasHiddenLabel
        value={secret}
        readOnly
        className="two-factor-auth-input text-center readonly"
      />
    )}
    <div className="two-factor-actions">
      <Button variant="primary" loading={loading} onClick={primaryAction}>
        <FormattedMessage id="TwoFactorAuthentication.Buttons.Next" />
      </Button>
      {onCancel &&
        (!gracePeriod ? (
          <SecondaryLink className="two-factor-cancel" onClick={onCancel}>
            <FormattedMessage id="TwoFactorAuthentication.Buttons.Cancel" />
          </SecondaryLink>
        ) : (
          <p>
            <FormattedMessage id="TwoFactorAuthentication.Texts.GracePeriod" values={{ count: gracePeriod }} />
            <SecondaryLink onClick={onCancel}>
              <FormattedMessage id="TwoFactorAuthentication.Buttons.SkipForNow" />
            </SecondaryLink>
          </p>
        ))}
    </div>
  </div>
);

export default SetupStep;
